import {graphql} from 'react-relay';
import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation DeleteSisenseUserMutation($input: DeleteSisenseUserInput!) {
		deleteSisenseUser(input: $input) {
			person {
				id
				sisenseUserId
			}
			viewer {
				id
				sisenseUserId
			}
			errors
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Sisense User Deleted');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
